import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2 py-0.5 text-sm font-black transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 uppercase tracking-wide font-milligram',
  {
    variants: {
      variant: {
        default:
          'bg-primary text-primary-foreground border-primary hover:bg-primary/90 focus:ring-primary',
        secondary:
          'bg-secondary text-secondary-foreground border-secondary hover:bg-secondary/90 focus:ring-secondary',
        accent:
          'bg-accent text-accent-foreground border-accent hover:bg-accent/90 focus:ring-accent',
        outline:
          'border border-input bg-background text-foreground hover:bg-accent hover:text-accent-foreground focus:ring-ring',
        destructive: 'bg-red-500 text-white border-red-500 hover:bg-red-500/90 focus:ring-red-500',
        ghost:
          'border-none bg-transparent text-muted-foreground hover:bg-accent hover:text-accent-foreground focus:ring-ring',
        // Brand-specific variants with proper contrast
        yellow:
          'bg-brand-yellow text-brand-black border-brand-yellow hover:bg-brand-yellow/90 focus:ring-brand-yellow',
        pink: 'bg-brand-pink text-brand-black border-brand-pink hover:bg-brand-pink/90 focus:ring-brand-pink',
        blue: 'bg-brand-blue text-white border-brand-blue hover:bg-brand-blue/90 focus:ring-brand-blue',
        // Semantic variants
        warning:
          'bg-amber-500 text-white border-amber-500 hover:bg-amber-500/90 focus:ring-amber-500',
        success:
          'bg-green-500 text-white border-green-500 hover:bg-green-500/90 focus:ring-green-500',
        info: 'bg-blue-500 text-white border-blue-500 hover:bg-blue-500/90 focus:ring-blue-500',
        error: 'bg-red-500 text-white border-red-500 hover:bg-red-500/90 focus:ring-red-500',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
